<template>
  <v-textarea
    v-bind="$attrs"
    v-model="value"
    :error-messages="errorMessage"
    color="szGrey"
    variant="outlined"
    class="custom-text-area"
    :class="{ 'required-label': required }"
  />
</template>

<script setup>
import { useField } from 'vee-validate'
import { toRef } from 'vue'

const props = defineProps({
  rules: {
    type: [Object, String],
    default: ''
  },
  required: {
    type: Boolean,
    default: false
  },
  name: {
    type: String,
    required: true
  },
  modelValue: {
    type: String,
    required: true
  }
})

const rulesRef = toRef(props, 'rules')

const { value, errorMessage } = useField(() => props.name, rulesRef, {
  syncVModel: true
})
</script>

<style lang="scss">
@use '@/assets/css/variables.scss' as variables;
@use 'sass:map';

.custom-text-area {
  @media screen and (min-width: map.get(variables.$grid-breakpoints, 'md')) {
    min-width: 450px;
  }
}
</style>
